import {
  UPDATE_BUSINESS_CASE_FORM_STATE,
  REVIEW_BUSINESS_CASE,
  INITIATE_EXISTING_BUSINESS_CASE,
  API_SAVE_BUSINESS_CASE_ENDPOINT,
  API_GET_BUSINESS_CASES_LIST_COMPLETE,
  API_GET_ALL_BUSINESS_CASES_ENDPOINT,
  INITIATE_BUSINESS_CASE_FORM_VALIDATION,
  COMPLETE_BUSINESS_CASE_FORM_VALIDATION,
  API_DELETE_BUSINESS_CASE_ENDPOINT,
  API_DELETE_BUSINESS_CASE_COMPLETE,
  INITIATE_NEW_BUSINESS_CASE,
  ACTIVATE_SELECTED_BUSINESS_CASE,
  API_NOTIFY_ENDPOINT,
  INITIATE_ACCOUNT_MANAGER_NOTIFICATION_PROCESS,
  COMPLETE_ACCOUNT_MANAGER_NOTIFICATION_PROCESS,
  API_DOWNLOAD_PDF_ENDPOINT,
  INITIATE_DOWNLOAD_PDF_PROCESS,
  COMPLETE_DOWNLOAD_PDF_PROCESS,
  SAVE_PRODUCTS_TO_BUSINESS_CASE,
  ROUTE_PATHS,
  APP_CONFIG,
} from '../../app-constants';
import { failureAction, downloadFileBlob } from '../../app-actions';
import { apiGet, apiPost, apiFileGet } from '../../api/api-configuration';
import history from '../../app-history';


export const updateBusinessCaseFormReduxState = formState => ({ type: UPDATE_BUSINESS_CASE_FORM_STATE, data: formState });

export const successGetAllBusinessCases = businessCasesListResponse =>
  ({ type: API_GET_BUSINESS_CASES_LIST_COMPLETE, data: businessCasesListResponse.data });

export const getAllBusinessCases = data => (dispatch) => {
  apiGet(dispatch, API_GET_ALL_BUSINESS_CASES_ENDPOINT, successGetAllBusinessCases, failureAction, data);
};

export const moveBusinessCaseToReview = businessCaseSaveResponse => ({ type: REVIEW_BUSINESS_CASE, data: businessCaseSaveResponse.data });

export const moveBusinessCaseToEdit = () => ({ type: INITIATE_EXISTING_BUSINESS_CASE });

export const prepareDataForMS = ({ bcbId, bcbObjective, bcbVersion, currency, selectedProducts, timeFrame, budget, bcbName }) => ({
  bcbId: bcbId || '',
  bcbObjective,
  bcbVersion,
  currency,
  selectedProducts,
  timeFrame,
  budget: budget.length > 0 ? budget.replace(/[$,]/g, '') : 0,
  bcbName,
});

export const saveBusinessCase = data => (dispatch) => {
  const preparedData = prepareDataForMS(data);
  apiPost(dispatch, API_SAVE_BUSINESS_CASE_ENDPOINT, moveBusinessCaseToReview, failureAction, preparedData);
};

export const validateBusinessCaseForm = (currentformState, businessCasesList, bcbData) => (dispatch) => {
  const bcbFormErrors = {
    bcbName: false,
  };

  dispatch({ type: INITIATE_BUSINESS_CASE_FORM_VALIDATION });
  if (bcbData.bcbName.toLowerCase().trim() !== currentformState.bcbName.toLowerCase().trim()) {
    const bcbCaseWithSameBcbNamePresent = businessCasesList
      .filter(bcbCase => bcbCase.bcbName.toLowerCase().trim() === currentformState.bcbName.toLowerCase().trim());

    if (bcbCaseWithSameBcbNamePresent.length > 0) {
      bcbFormErrors.bcbName = true;
    }
  }
  dispatch({ type: COMPLETE_BUSINESS_CASE_FORM_VALIDATION, data: bcbFormErrors });
};

export const successDeleteBusinessCase = (deleteBusinessCaseResponse) => {
  const myBusinessCaseRoute = `${APP_CONFIG.reactBasePath}${ROUTE_PATHS.myBusinessCases.route}`;
  history.push(myBusinessCaseRoute);
  return { type: API_DELETE_BUSINESS_CASE_COMPLETE, data: deleteBusinessCaseResponse.data };
};

export const deleteBusinessCase = data => (dispatch) => {
  const deleteRequestData = { bcbId: data.bcbId };
  apiPost(dispatch, API_DELETE_BUSINESS_CASE_ENDPOINT, successDeleteBusinessCase, failureAction, deleteRequestData);
};

export const startNewBusinessCase = () => (dispatch) => {
  const emptyBcbData = {
    bcbId: '',
    bcbVersion: '',
    bcbName: '',
    bcbObjective: '',
    budget: 0,
    currency: 'AUD',
    timeFrame: '',
    selectedProducts: [],
    createdDate: '',
    updatedDate: '',
  };

  const bcbFormErrors = {
    bcbName: false,
  };

  dispatch({ type: INITIATE_NEW_BUSINESS_CASE, data: { bcbData: emptyBcbData, errors: bcbFormErrors } });
};

export const setActiveBusinessCase = (data) => {
  const businessCaseRoute = `${APP_CONFIG.reactBasePath}${ROUTE_PATHS.businessCase.route}`;
  history.push(businessCaseRoute);
  return { type: ACTIVATE_SELECTED_BUSINESS_CASE, data: { bcbId: data.bcbId, isEditing: data.setFormToEdit } };
};

export const successNotificationProcess = () => ({ type: COMPLETE_ACCOUNT_MANAGER_NOTIFICATION_PROCESS });

export const startNotificationProcess = data => (dispatch) => {
  const endpoint = `${API_NOTIFY_ENDPOINT}?bcbId=${data.bcbId}`;
  dispatch({ type: INITIATE_ACCOUNT_MANAGER_NOTIFICATION_PROCESS });
  apiGet(dispatch, endpoint, successNotificationProcess, failureAction);
};

export const successDownloadPdfProcess = (response) => {
  downloadFileBlob(response, 'business-case.pdf', 'application/pdf');
  return ({ type: COMPLETE_DOWNLOAD_PDF_PROCESS });
};

export const startDownloadPdfProcess = data => (dispatch) => {
  const endpoint = `${API_DOWNLOAD_PDF_ENDPOINT}?bcbId=${data.bcbId}`;
  dispatch({ type: INITIATE_DOWNLOAD_PDF_PROCESS });
  apiFileGet(dispatch, endpoint, successDownloadPdfProcess, failureAction);
};

export const saveSelectedProductsToBusinessCase = data => (dispatch) => {
  const selectedProducts = data.productRecommendation.map(
    ({ recommendedProductCode,
      recommendedProductName,
      recommendationCode,
      recommendedProductSummary }) => ({
      recommendedProductCode,
      recommendedProductName,
      recommendationCode,
      recommendedProductSummary,
    }));
  dispatch({ type: SAVE_PRODUCTS_TO_BUSINESS_CASE, data: { selectedProducts } });
};
